/*
 * 文件EN: APIList.js,
 * 文件CN: 项目列表,
 * 创建时间: Wednesday, 17th June 2020 9:51:13 am,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */

import request from '@/plugins/http'

/**
 * @desc 列表获取
 * @method GET
 * @param {参数说明 详细见 swagger}
 */
export const getListData = params => {
  return request.get('/apiManager/apiList/queryApiList', params)
}

/**
 * @desc 详情
 * @method GET
 * @param {id 项目列表的id int类型}
 */
export const fetchDetails = params => {
  return request.get('/apiManager/apiList/queryApiDetail', params)
}

/**
 * @desc Api项目列表 - 请求参数查询
 * @method GET
 * @param {apiCode: API编号, type: 指定请求的参数类型, dataType: 请求体类型}
 */
export const queryApiReqParam = params => {
  return request.get('/apiManager/apiList/queryApiReqParam', params)
}

/**
 * @desc Api项目列表 - 返回参数查询
 * @method GET
 * @param {apiCode: API编号}
 */
export const queryApiParam = params => {
  return request.get('/apiManager/apiList/queryApiParam', params)
}

/**
 * @desc 错误码列表 返回参数 请求参数 成功示例
 * @method GET
 * @param {apiCode: API编号}
 */
export const queryParams = params => {
  return request.get('/apiManager/apiList/queryParams', params)
}

/**
 * @desc 调用权限列表的查询
 * @method GET
 * @param {参数说明 详细 见swagger}
 */
export const queryApiAuthorizeList = params => {
  return request.get('/apiManager/apiList/queryApiAuthorizeList', params)
}

// 新增 修改操作

/**
 * @desc api 新增
 * @method POST
 * @param {参数说明 详细 见swagger}
 */
export const saveapi = params => {
  return request.post('/apiManager/apiList/saveapi', params, { json: true })
}

/**
 * @desc api 修改
 * @method POST
 * @param {参数说明 详细 见swagger}
 */
export const updateApi = params => {
  return request.post('/apiManager/apiList/updateApi', params, { json: true })
}

/**
 * @desc 启用
 * @method POST
 * @param {apiCode}
 */
export const onStart = params => {
  return request.post('/apiManager/apiList/startApi', params, { json: true })
}

/**
 * @desc 停用
 * @method POST
 * @param {apiCode}
 */
export const onStop = params => {
  return request.post('/apiManager/apiList/stopApi', params, { json: true })
}

// /**
//  * @desc Api项目列表 - 详情修改
//  * @method POST
//  * @param {参数说明 详细 见swagger}
//  */
// export const updateApiDetail = params => {
//   return request.post(/apiManager/apiList/updateApiDetail', params)
// }

// /**
//  * @desc 参数批量修改
//  * @method POST
//  * @param {参数说明 详细 见swagger}
//  */
// export const updateApiParam = params => {
//   return request.post('/apiManager/apiList/updateApiParam', params)
// }

// /**
//  * @desc 授权信息批量修改
//  * @method POST
//  * @param {参数说明 详细 见swagger}
//  */
// export const updateApiAuthorize = params => {
//   return request.post('/apiManager/apiList/updateApiAuthorize', params )
// }
